<template>
  <Card>
    <template #title="">
      <div class="p-d-flex p-justify-between">
        ประเภททักษะ
        <div>
          <Button
            label="สร้างใหม่"
            icon="pi pi-plus"
            class="p-ml-2"
            @click="onNewSkill"
          ></Button>

          <back-button class="p-ml-2" />
        </div>
      </div>
    </template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-12">
          <div class="p-grid">
            <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-search"></i>
                </span>
                <InputText
                  v-model="searchString"
                  placeholder="ระบุคำค้น"
                ></InputText>
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-12">
          <DataTable
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[10, 20, 50]"
            :value="filteredSkill"
            class="p-datatable-sm"
            ref="skillTable"
            dataKey="id"
          >
            <template #empty>ไม่พบข้อมูล</template>
            <Column field="id" header="รหัส" :sortable="true"> </Column>
            <Column
              field="descriptionEN"
              header="Description (EN)"
              :sortable="true"
            >
            </Column>
            <Column
              field="descriptionTH"
              header="Description (TH)"
              :sortable="true"
            >
            </Column>
            <Column headerStyle="width: 7rem" bodyStyle="width: 7rem">
              <template #body="props">
                <Button
                  class="p-button-rounded p-button-success p-mr-2"
                  icon="pi pi-pencil"
                  @click="onEditSkill(props.data)"
                ></Button>
                <Button
                  class="p-button-rounded p-button-warning"
                  icon="pi pi-trash"
                  @click="onDeleteSkill(props.data)"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </template>
  </Card>
  <Dialog v-model:visible="showDialog" :modal="true" class="p-fluid">
    <div class="p-field">
      <label for="skillId">รหัส</label>
      <InputText
        maxlength="3"
        id="username"
        v-model.trim="skill.id"
        required="true"
        :disabled="existSkillId"
        autofocus
        :class="{ 'p-invalid': submitted && !skill.id }"
      >
      </InputText>
      <small class="p-error" v-if="submitted && !skill.id">
        โปรดกรอกรหัส
      </small>
      <small class="p-error" v-if="duplicateSkillId"> รหัสซ้ำ </small>
    </div>
    <div class="p-field">
      <label for="name">Description (EN)</label>
      <InputText
        id="name"
        v-model="skill.descriptionEN"
        maxlength="50"
      ></InputText>
    </div>
    <div class="p-field">
      <label for="name">Description (TH)</label>
      <InputText
        id="name"
        v-model="skill.descriptionTH"
        maxlength="50"
      ></InputText>
    </div>
    <template #footer>
      <Button
        icon="pi pi-check"
        label="ยืนยัน"
        class="p-button-success"
        @click="onSaveSkill"
      ></Button>
      <Button
        icon="pi pi-times"
        label="ยกเลิก"
        class="p-button-danger p-ml-2"
        @click="onHideDialog"
      ></Button>
    </template>
  </Dialog>
  <!-- <PopupConfirmDelete
		:value="skill.skillId"
		v-if="popupDeleteDialog"
	/> -->
  <Dialog
    v-model:visible="popupDeleteDialog"
    :style="{ width: '450px' }"
    header="Confirm"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span v-if="skill"
        >Are you sure you want to delete <b>{{ skill.id }}</b
        >?</span
      >
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        class="p-button-text"
        @click="popupDeleteDialog = false"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        class="p-button-text"
        @click="handleDeleteSkill"
      />
    </template>
  </Dialog>
</template>

<script lang="ts">
import { ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { clone } from "ramda";
import { Skill, GetSkillResponse, UpsertSkillRequest } from "@/types";
import Fuse from "fuse.js";
import BackButton from "@/components/BackButton.vue";
export default {
  name: "Skill",
  components: { BackButton },
  setup() {
    const { success, error, axios, setLoading, padZero } = usePlugin();

    const skillTable = ref(null);
    const skills = ref<Skill[]>([]);
    const skill = ref<Skill>({} as Skill);
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const existSkillId = ref(false);
    const duplicateSkillId = ref(false);

    const filteredSkill = computed(() => {
      if (!searchString.value) return skills.value;
      const fuse = new Fuse(skills.value, {
        keys: ["skillId", "descriptionEN", "descriptionTH"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const loadSkills = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetSkillResponse>(
          "api/v1/services/skill/get"
        );
        skills.value = result.data.skills ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onNewSkill = () => {
      skill.value = {} as Skill;
      showDialog.value = true;
      submitted.value = false;
      existSkillId.value = false;
    };

    const onSaveSkill = async () => {
      submitted.value = true;

      if (skill.value.id && skill.value.id.length > 0) {
        if (
          !existSkillId.value &&
          skills.value.find((comp) => comp.id === padZero(skill.value.id, 3))
        ) {
          //Create skill ID
          duplicateSkillId.value = true;
          return;
        }
        setLoading(true);
        try {
          const result = await axios.post("api/v1/services/skill/upsert", {
            skills: [
              {
                id: padZero(skill.value.id, 3),
                descriptionTH: skill.value.descriptionTH,
                descriptionEN: skill.value.descriptionEN,
              },
            ],
          } as UpsertSkillRequest);
          await loadSkills();
          success("บันทึกข้อมูลสำเร็จแล้ว");
          showDialog.value = false;
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
      duplicateSkillId.value = false;
    };

    const onEditSkill = (source: Skill) => {
      skill.value = clone(source);
      showDialog.value = true;
      existSkillId.value = true;
    };

    const onDeleteSkill = (source: Skill) => {
      skill.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const handleDeleteSkill = async () => {
      setLoading(true);
      try {
        const result = await axios.delete("api/v1/services/skill/delete", {
          data: {
            skills: [skill.value],
          } as UpsertSkillRequest,
        });
        await loadSkills();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      // }
    };

    onMounted(async () => {
      await loadSkills();
    });
    return {
      skillTable,
      skill,
      skills,
      filteredSkill,
      showDialog,
      submitted,
      existSkillId,
      duplicateSkillId,
      popupDeleteDialog,
      searchString,
      onNewSkill,
      onEditSkill,
      onDeleteSkill,
      onSaveSkill,
      handleDeleteSkill,
      onHideDialog,
    };
  },
};
</script>
